export const bonus = 400; // Введите очки из игры, не обманывайте нас :(
export const orders = 0;
